import React from 'react';

import { SVGIcon } from 'UIKit/index';
import Dashboard from 'Assets/images/AppLogo/dashboard.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + Dashboard + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCDashboardMenu(props) {
    return <SVGIcon {...props} viewBox="0 0 2000 2000" style={backgroundStyle} />;
}
